import React from "react";
import { Button, Form, FormControl, InputGroup } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";
import { isMobile } from "react-device-detect";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import { getFullName } from "../../../Modules/utils/fullname";
import RenderAmount from "../../../Components/etc/RenderAmount";
import AppTable from "../../Components/AppTable";
import AccountDetails from "../AccountsScreen/AccountDetails";
import {
  calcTotalOfList,
  dayDiff,
  monthDiff,
} from "../../../Modules/utils/etc";

const SCREEN_NAME = "REPORTS_SCREEN";

class AccountsByEndingDateInner extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleModal: null,
      modalData: null,
      period: "monthly",
      range0: null,
      range1: null,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      accounts: [],
    };

    let columns = [
      {
        value: "sl",
        label: "SL No",
        render: ({ index }) => index,
      },
      {
        value: "shortId",
        label: "ID",
        render: ({ item }) => (
          <div
            className="hoveredlink"
            onClick={(e) => {
              e.stopPropagation();
              this.setAsyncState({
                visibleModal: "accountDetails",
                modalData: { account: item },
              });
            }}
          >
            {item?.shortId}
          </div>
        ),
      },
      {
        value: "accountType",
        label: "Account Type",
        render: ({ item }) => _.startCase(item.accountType),
      },
      {
        value: "name",
        label: "Name",
        render: ({ item }) => getFullName(item.customer),
      },

      {
        value: "interestRate",
        label: "Interest Rate",
        render: ({ item }) =>
          item.interestRate ? (
            <div className="numeric">{item.interestRate}%</div>
          ) : (
            ""
          ),
        // hideInMobile: true,
      },
      // {
      //   value: "period",
      //   label: "Period",
      //   render: ({ item }) =>
      //     _.startCase(
      //       item.accountType === "deposit"
      //         ? item.depositInterval
      //         : item.interestPeriod
      //     ),
      //   // hideInMobile: true,
      // },
      {
        value: "openingDate",
        label: "Opening Date",
        render: ({ item }) =>
          item.openingDate || item.createdAt
            ? new Date(
                item.accountType === "deposit"
                  ? item.openingDate
                  : item.createdAt
              ).toLocaleDateString()
            : null,
        hideInMobile: true,
      },
      {
        value: "endingDate",
        label: "Ending Date",
        render: ({ item }) => (
          <>
            {item.endingDate
              ? new Date(item.endingDate).toLocaleDateString()
              : null}
          </>
        ),
      },
      {
        value: "returningDate",
        label: "Returning Date",
        render: ({ item }) => (
          <b>
            {item.returningDate
              ? new Date(item.returningDate).toLocaleDateString()
              : null}
          </b>
        ),
      },
      { value: "recurringAmount", label: "Recurring Amount" },
      {
        value: "noOfMonths",
        label: "Period (month)",
      },
      {
        value: "balance",
        label: "Balance",
        render: ({ item }) => (
          <RenderAmount value={item.balance?.toFixed?.(2)} />
        ),
      },
      {
        value: "payableOnBalance",
        label: "Balance with interest",
        render: ({ item }) => (
          <RenderAmount value={item.payableOnBalance?.toFixed?.(2)} />
        ),
      },
      {
        value: "estFinalBalance",
        label: "Estimated Final Balance",
        render: ({ item }) => (
          <RenderAmount value={item.estFinalBalance?.toFixed?.(2)} />
        ),
      },
      {
        value: "payableOnEstFinalBalance",
        label: "Est Final With Interest",
        render: ({ item }) => (
          <RenderAmount value={item.payableOnEstFinalBalance?.toFixed?.(2)} />
        ),
      },
      {
        value: "closed",
        label: "Status",
        render: ({ item }) =>
          item.closed ? (
            <span style={{ color: "red" }}>Closed</span>
          ) : (
            <span style={{ color: "green" }}>Active</span>
          ),
      },
      // {
      //   value: "note",
      //   label: "Note",
      //   render: ({ item }) =>
      //     item.note?.length > 15 ? item.note.substr(0, 15) + "..." : item.note,
      //   hideInMobile: true,
      // },
    ].filter((x) => (isMobile ? !x.hideInMobile : true));

    if (this.props.filteredColumns) {
      let newColumns = [];

      for (let i = 0; i < this.props.filteredColumns.length; i++) {
        const colValue = this.props.filteredColumns[i];

        const col = columns.find((x) => x.value === colValue);
        if (col) {
          newColumns.push(col);
        }
      }

      this.columns = newColumns;
    } else {
      this.columns = columns;
    }

    this.months = "January, February, March, April, May, June, July, August, September, October, November, December"
      .split(",")
      .map((x) => x.trim());
  }

  componentDidMount() {
    this.onMount();
    this.onSubmit();
    this.loadAgents();
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      let range0, range1;
      if (this.state.period === "monthly") {
        let refDate = new Date(this.state.year, this.state.month);

        range0 = refDate.getTime();
        range1 = new Date(refDate).setMonth(refDate.getMonth() + 1);
      } else {
        range0 = new Date(this.state.range0).setHours(0, 0, 0, 0);
        range1 = new Date(this.state.range1).setHours(0, 0, 0, 0);
      }

      this.setAsyncState({ loading: true, error: null });

      let accountsWhereQuery = {
        accountType: "deposit",
        returningDate: { $gte: new Date(range0), $lt: new Date(range1) },
      };
      if (this.state.selectedAgent) {
        accountsWhereQuery.collector = this.state.selectedAgent;
      }
      const res = await api.get("v1/account", {
        queryStr: JSON.stringify({
          where: accountsWhereQuery,
          populate: "customer",
        }),
      });

      const accounts = res.accounts.map((account) => {
        let noOfMonths = monthDiff(account.openingDate, account.endingDate);

        let estFinalBalance = account.balance;
        if (
          !account.closed &&
          Date.now() < new Date(account.endingDate).getTime()
        ) {
          if (account.depositInterval === "daily") {
            let noOfDays = dayDiff(account.openingDate, account.endingDate);
            estFinalBalance = -1 * parseInt(noOfDays) * account.recurringAmount;
          } else {
            // let remainingMonths = parseInt(
            //   monthDiff(new Date(), account.endingDate)
            // );
            // let remainingBalance = (remainingMonths-1) * account.recurringAmount;
            // estFinalBalance -= remainingBalance;

            estFinalBalance =
              -1 * parseInt(noOfMonths) * account.recurringAmount;
          }
        }

        let payableOnBalance =
          (account.balance || 0) * (account.interestRate * 0.01 + 1);
        let payableOnEstFinalBalance =
          (estFinalBalance || 0) * (account.interestRate * 0.01 + 1);

        return {
          ...account,
          noOfMonths,
          estFinalBalance,
          payableOnBalance,
          payableOnEstFinalBalance,
        };
      });

      const calculatedTotal = calcTotalOfList(accounts, [
        "balance",
        "estFinalBalance",
        "payableOnBalance",
        "payableOnEstFinalBalance",
      ]);

      let total = {
        ...calculatedTotal,
        _id: "total",
        customer: { firstName: "Total" },
      };

      this.setAsyncState({ accounts: accounts, loading: false, total });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  async loadAgents() {
    try {
      const { agents } = await api.get("v1/agent", {
        queryStr: JSON.stringify({}),
      });
      this.setAsyncState({ agents });
    } catch (e) {
      console.error("Error loading agents: ", e.message);
    }
  }

  render() {
    const {
      state: {
        month,
        year,
        loading,
        error,
        visibleModal,
        modalData,
        accounts,
        total,
        selectedAgent,
        agents,
      },
      props: { title },
    } = this;

    const accountsWithTotal = accounts?.length ? [total, ...accounts] : [];

    const collerctorSelector = (
      <FormControl
        as="select"
        value={selectedAgent || ""}
        onChange={(e) =>
          this.setAsyncState({ selectedAgent: e.target.value }).then(() =>
            this.onSubmit()
          )
        }
      >
        <option value="">All Agents</option>
        {agents?.map((x) => (
          <option key={x._id} value={x._id}>
            {getFullName(x)}
          </option>
        ))}
      </FormControl>
    );

    const content = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">
              {title || "Deposit Accounts By Returning Date"}
            </div>
          </div>
          <div className="right">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                this.onSubmit();
              }}
            >
              <InputGroup className="mb-3">
                {collerctorSelector}
                <FormControl
                  value={month || ""}
                  onChange={(e) => this.setState({ month: e.target.value })}
                  as="select"
                  required
                >
                  <option value="">Select Month</option>
                  {this.months.map((x, i) => (
                    <option key={i} value={i}>
                      {x}
                    </option>
                  ))}
                </FormControl>
                <FormControl
                  type="number"
                  value={year || ""}
                  onChange={(e) => this.setState({ year: e.target.value })}
                  placeholder="Year"
                  required
                />

                <Button disabled={loading} type="submit">
                  Load
                </Button>
              </InputGroup>
            </Form>
          </div>
        </div>

        <div>
          <AppTable
            {...{
              items: accountsWithTotal,
              loading,
              error,
              table: {
                columns: this.columns,
                getStyle: ({ item }) =>
                  item._id === "total"
                    ? { color: "blue", fontWeight: "bold" }
                    : null,
                // onRowClick: ({ item, index }) =>
                //   this.setAsyncState({
                //     visibleModal: "transactionDetails",
                //     modalData: { transaction: item, index },
                //   }),
              },
            }}
          />
        </div>

        <AccountDetails
          {...{
            key: `accountDetails-${
              visibleModal === "accountDetails"
                ? modalData?.account?.shortId || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "accountDetails",
            shortId: modalData?.account?.shortId,
            handleClose: () => this.setAsyncState({ visibleModal: null }),

            ...(modalData || {}),
          }}
        />
      </div>
    );

    return content;
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const AccountsByEndingDate = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountsByEndingDateInner);

export default AccountsByEndingDate;
